const ComponentsLookup = {
  "default-footer": "DefaultFooterDd7bd5a62f4c4126B1ed20c63f66aad0"
}

export default ComponentsLookup;